<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb>
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>工单管理</el-breadcrumb-item>
        <el-breadcrumb-item>Dcops工单</el-breadcrumb-item>
        <el-breadcrumb-item>TPC异常处理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="建单时间">
                <el-date-picker
                  v-model="searchForm.create_time"
                  type="daterange"
                  range-separator="-"
                  style="width: 100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否超时">
                <el-select
                  v-model="searchForm.is_timeout"
                  clearable
                  placeholder="全部"
                  style="width: 100%"
                >
                  <el-option label="是" value="是" />
                  <el-option label="否" value="否" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单号">
                <el-input v-model="searchForm.ticket_id" clearable placeholder="请输入工单号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态">
                <el-input v-model="searchForm.status" clearable placeholder="如 处理中" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="区域-园区">
                <el-select
                  v-model="searchForm.campus"
                  clearable
                  filterable
                  placeholder="请选择"
                  @focus="handleSelectFocus"
                >
                  <el-option v-for="item in campusOptions" :key="item" :label="item" :value="item" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="处理人">
                <el-input v-model="searchForm.handle_user" clearable placeholder="支持模糊搜索" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="SN">
                <el-input v-model="searchForm.sn" clearable placeholder="明细 SN" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="固资">
                <el-input v-model="searchForm.asset_id" clearable placeholder="明细固资号" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <div class="title-en">TPC异常处理列表</div>
    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button type="success" plain :loading="syncLoading" :disabled="syncLoading" @click="openSyncDialog">
            更新TPC列表
          </el-button>
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>

        <el-table
          ref="table"
          v-loading="loading"
          class="tpc-table"
          style="width: 100%"
          :data="showData"
          border
          stripe
          row-key="ticket_id"
          @selection-change="handleSelectionChange"
          @expand-change="handleExpand"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column
            v-for="(column, index) in visibleColumns"
            :key="index"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.minWidth"
            :width="column.width"
            :align="column.align"
            :show-overflow-tooltip="column.tooltip !== false"
          >
            <template slot-scope="scope">
              <template v-if="column.prop === 'ticket_id'">
                <span>{{ scope.row.ticket_id || '-' }}</span>
              </template>
              <template v-else-if="column.prop === 'status'">
                <el-tag :type="statusTagType(scope.row.status)" size="small">{{ scope.row.status || '-' }}</el-tag>
              </template>
              <template v-else-if="column.prop === 'is_timeout'">
                <el-tag
                  v-if="scope.row.is_timeout === '是'"
                  type="danger"
                  size="small"
                  effect="dark"
                >
                  是
                </el-tag>
                <el-tag
                  v-else-if="scope.row.is_timeout === '否'"
                  type="success"
                  size="small"
                  effect="plain"
                >
                  否
                </el-tag>
                <span v-else>{{ formatCell(scope.row, column.prop) }}</span>
              </template>
              <span v-else>{{ formatCell(scope.row, column.prop) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            type="expand"
            label="工单详情"
            width="88"
            align="center"
            fixed="right"
            class-name="tpc-detail-expand-col"
          >
            <template slot-scope="props">
              <div
                v-loading="detailLoadingMap[props.row.ticket_id]"
                class="detail-expand-wrap"
              >
                <div class="detail-summary-bar">
                  <el-tag type="primary" effect="plain" size="small">
                    共 {{ (detailMap[props.row.ticket_id] || []).length }} 台设备
                  </el-tag>
                  <span class="detail-summary-id">工单号：{{ props.row.ticket_id }}</span>
                </div>
                <el-empty
                  v-if="!(detailMap[props.row.ticket_id] || []).length && !detailLoadingMap[props.row.ticket_id]"
                  description="暂无设备明细"
                  :image-size="72"
                />
                <div
                  v-for="(device, dIdx) in detailMap[props.row.ticket_id] || []"
                  :key="device.id || dIdx"
                  class="device-card"
                >
                  <div class="device-card-header">
                    <span class="device-badge">设备 {{ dIdx + 1 }}</span>
                    <span class="device-asset">{{ displayDetail(device, 'asset_id') }}</span>
                    <el-tag
                      v-if="device.is_ai_model === '是'"
                      size="mini"
                      type="warning"
                      effect="plain"
                    >
                      AI服务器
                    </el-tag>
                    <el-tag
                      v-if="device.is_timeout === '是'"
                      size="mini"
                      type="danger"
                      effect="dark"
                    >
                      超时
                    </el-tag>
                    <el-tag
                      v-else-if="device.is_timeout === '否'"
                      size="mini"
                      type="success"
                      effect="plain"
                    >
                      未超时
                    </el-tag>
                  </div>
                  <el-row :gutter="16" class="device-card-body">
                    <el-col :span="8">
                      <div class="info-panel">
                        <div class="panel-title"><i class="el-icon-cpu" /> 设备信息</div>
                        <el-descriptions :column="1" size="small" border>
                          <el-descriptions-item label="SN">{{ displayDetail(device, 'sn') }}</el-descriptions-item>
                          <el-descriptions-item label="是否AI服务器">{{ displayDetail(device, 'is_ai_model') }}</el-descriptions-item>
                          <el-descriptions-item label="机型">{{ displayDetail(device, 'model') }}</el-descriptions-item>
                          <el-descriptions-item label="一级机房">{{ displayDetail(device, 'idcp_name') }}</el-descriptions-item>
                          <el-descriptions-item label="机房单元">{{ displayDetail(device, 'idc_name') }}</el-descriptions-item>
                          <el-descriptions-item label="机架/机位">
                            {{ displayDetail(device, 'rack_name') }} / {{ displayDetail(device, 'pos_name') }}
                          </el-descriptions-item>
                          <el-descriptions-item label="操作类型">
                            <el-tag size="mini" type="info">{{ displayDetail(device, 'cztype', 'cztype') }}</el-tag>
                          </el-descriptions-item>
                          <el-descriptions-item label="场景">{{ displayDetail(device, 'scene') }}</el-descriptions-item>
                        </el-descriptions>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="info-panel">
                        <div class="panel-title"><i class="el-icon-warning-outline" /> 异常信息</div>
                        <el-descriptions :column="1" size="small" border>
                          <el-descriptions-item label="异常类型">{{ displayDetail(device, 'event_type') }}</el-descriptions-item>
                          <el-descriptions-item label="异常描述">
                            <span class="text-block">{{ displayDetail(device, 'exception') }}</span>
                          </el-descriptions-item>
                          <el-descriptions-item label="结单描述">
                            <span class="text-block">{{ displayDetail(device, 'handle_detail') }}</span>
                          </el-descriptions-item>
                          <el-descriptions-item label="结单异常类型">{{ displayDetail(device, 'end_exception_item') }}</el-descriptions-item>
                        </el-descriptions>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="info-panel">
                        <div class="panel-title"><i class="el-icon-time" /> 超时与操作</div>
                        <el-descriptions :column="1" size="small" border>
                          <el-descriptions-item label="是否超时">{{ displayDetail(device, 'is_timeout') }}</el-descriptions-item>
                          <el-descriptions-item label="一级原因">{{ displayDetail(device, 'first_timeout_reason') }}</el-descriptions-item>
                          <el-descriptions-item label="二级原因">{{ displayDetail(device, 'second_timeout_reason') }}</el-descriptions-item>
                          <el-descriptions-item label="超时描述">
                            <span class="text-block">{{ displayDetail(device, 'timeout_desc') }}</span>
                          </el-descriptions-item>
                          <el-descriptions-item label="申请免责">{{ displayDetail(device, 'apply_impunity') }}</el-descriptions-item>
                          <el-descriptions-item label="到达现场">{{ displayDetail(device, 'arrive_site_time', 'date') }}</el-descriptions-item>
                          <el-descriptions-item label="开始操作">{{ displayDetail(device, 'start_operate_time', 'date') }}</el-descriptions-item>
                        </el-descriptions>
                        <div v-if="device.arrive_site_time || device.start_operate_time" class="mini-timeline">
                          <div v-if="device.arrive_site_time" class="timeline-node">
                            <span class="dot on" />
                            <span class="label">到达现场</span>
                            <span class="time">{{ formatTime(device.arrive_site_time) }}</span>
                          </div>
                          <div v-if="device.start_operate_time" class="timeline-node">
                            <span class="dot on" />
                            <span class="label">开始操作</span>
                            <span class="time">{{ formatTime(device.start_operate_time) }}</span>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <div class="attach-panel">
                    <div class="panel-title"><i class="el-icon-picture-outline" /> 附件与举证</div>
                    <el-row :gutter="16">
                      <el-col
                        v-for="block in urlFieldBlocks(device)"
                        :key="block.prop"
                        :span="8"
                      >
                        <div class="url-block">
                          <div class="url-block-label">{{ block.label }}</div>
                          <div v-if="!block.urls.length" class="url-empty">---</div>
                          <div v-else class="url-block-content">
                            <template v-for="(url, uIdx) in block.urls">
                              <div
                                v-if="isValidUrl(url) && isImageUrl(url)"
                                :key="block.prop + '-img-' + uIdx"
                                class="url-image-item"
                              >
                                <el-image
                                  :src="url"
                                  fit="cover"
                                  class="url-preview-img"
                                  :preview-src-list="block.imageUrls"
                                />
                              </div>
                              <a
                                v-else-if="isValidUrl(url)"
                                :key="block.prop + '-dl-' + uIdx"
                                class="url-download-link"
                                :href="url"
                                target="_blank"
                                rel="noopener noreferrer"
                                @click.stop
                              >
                                <i class="el-icon-download" /> 下载链接
                              </a>
                              <span v-else :key="block.prop + '-na-' + uIdx" class="url-not-link">---</span>
                            </template>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="选择月份范围" :visible.sync="monthSelectDialogVisible" width="700px" :close-on-click-modal="false">
          <el-form :model="monthSelectForm" label-width="100px">
            <el-form-item label="开始月份">
              <el-date-picker
                v-model="monthSelectForm.startMonth"
                type="month"
                placeholder="选择开始月份"
                value-format="yyyy-MM"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item label="结束月份">
              <el-date-picker
                v-model="monthSelectForm.endMonth"
                type="month"
                placeholder="选择结束月份"
                value-format="yyyy-MM"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="monthSelectDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmSyncMonthSelect">确定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" width="420px" :close-on-click-modal="false">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getDcopsTpcCampusOptions,
  getServerTpcDetail,
  getServerTpcList,
  UpdateServerTpcList,
} from '@/api/dcopsTicket';
import dcopsTicketSyncLoading from '@/mixins/dcopsTicketSyncLoading';
import { debounce } from 'lodash';
import * as XLSX from 'xlsx';

const DATE_FIELDS = ['create_time', 'end_time'];
const DETAIL_DATE_FIELDS = ['arrive_site_time', 'start_operate_time'];

/** 与 GetTicketList_TPC.md 明细接口字段一致 */
const DETAIL_COLUMNS = [
  { prop: 'asset_id', label: '固资', minWidth: 140 },
  { prop: 'sn', label: 'SN', minWidth: 140 },
  { prop: 'is_ai_model', label: '是否AI服务器', minWidth: 110 },
  { prop: 'model', label: '机型', minWidth: 120 },
  { prop: 'idcp_name', label: '一级机房', minWidth: 140 },
  { prop: 'idc_name', label: '机房单元', minWidth: 180 },
  { prop: 'rack_name', label: '机架', minWidth: 110 },
  { prop: 'pos_name', label: '机位', minWidth: 80, align: 'center' },
  { prop: 'event_type', label: '异常类型', minWidth: 110 },
  { prop: 'exception', label: '异常描述', minWidth: 200 },
  { prop: 'handle_detail', label: '异常类型结单描述', minWidth: 140 },
  { prop: 'end_exception_item', label: '结单异常类型', minWidth: 140 },
  { prop: 'scene', label: '场景', minWidth: 100 },
  { prop: 'cztype', label: '操作类型', minWidth: 100, valueType: 'cztype' },
  { prop: 'is_timeout', label: '是否超时', minWidth: 90, align: 'center' },
  { prop: 'first_timeout_reason', label: '一级超时原因', minWidth: 120 },
  { prop: 'second_timeout_reason', label: '二级超时原因', minWidth: 140 },
  { prop: 'timeout_desc', label: '超时描述', minWidth: 140 },
  { prop: 'apply_impunity', label: '是否申请免责', minWidth: 110 },
  { prop: 'timeout_evidence', label: '超时免责举证', minWidth: 120, type: 'urls' },
  { prop: 'arrive_site_time', label: '到达现场', minWidth: 158 },
  { prop: 'start_operate_time', label: '开始操作', minWidth: 158 },
  { prop: 'abnormalequipment', label: '异常设备固资卡照片', minWidth: 130, type: 'urls' },
  { prop: 'abnormalissue', label: '异常问题转故障照片', minWidth: 140, type: 'urls' },
];

export default {
  name: 'DcopsServerTpc',
  mixins: [dcopsTicketSyncLoading],
  data() {
    const cols = [
      { prop: 'ticket_id', label: 'dcops单号', minWidth: 150 },
      { prop: 'status', label: '工单状态', minWidth: 100 },
      { prop: 'amount', label: '每单台数', minWidth: 90, align: 'center' },
      { prop: 'campus', label: '园区', minWidth: 110 },
      { prop: 'idcp_name', label: '一级机房', minWidth: 140 },
      { prop: 'handle_user', label: '处理人', minWidth: 130 },
      { prop: 'instance_id', label: '上游单号', minWidth: 160 },
      { prop: 'create_time', label: '建单时间', minWidth: 158 },
      { prop: 'end_time', label: '结单时间', minWidth: 158 },
      { prop: 'is_timeout', label: '是否超时', minWidth: 100, align: 'center' },
    ];
    const defaults = [
      'ticket_id',
      'status',
      'amount',
      'campus',
      'idcp_name',
      'handle_user',
      'create_time',
      'end_time',
      'is_timeout',
    ];
    return {
      columns: cols,
      selectedColumns: [...defaults],
      defaultSelectedColumns: [...defaults],
      visibleColumns: [],
      selectedRows: [],
      showData: [],
      dcopsSyncKey: 'tpc',
      loading: false,
      exportLoading: false,
      hasLoaded: false,
      campusOptions: [],
      monthSelectDialogVisible: false,
      showColumnsDialog: false,
      monthSelectForm: {
        startMonth: this.$moment().subtract(1, 'month').format('YYYY-MM'),
        endMonth: this.$moment().format('YYYY-MM'),
      },
      searchForm: {
        create_time: [],
        start_time: null,
        end_time: null,
        is_timeout: '',
        ticket_id: '',
        campus: '',
        status: '',
        handle_user: '',
        sn: '',
        asset_id: '',
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      detailMap: {},
      detailLoadingMap: {},
      expandedRows: [],
      detailColumns: DETAIL_COLUMNS,
    };
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  created() {
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.searchForm.create_time = [
      this.$moment(startDate).format('YYYY-MM-DD'),
      this.$moment(endDate).format('YYYY-MM-DD'),
    ];
    this.handleDateChange(this.searchForm.create_time);
    this.visibleColumns = this.columns.filter((x) => this.selectedColumns.includes(x.prop));
    this.fetchList();
    this.getCampusData();
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    statusTagType(status) {
      if (!status) return '';
      const s = String(status);
      if (s.includes('完成') || s.includes('结单') || s.includes('终止')) return 'success';
      if (s.includes('中')) return 'warning';
      return '';
    },
    formatTime(value) {
      if (!value) return '-';
      const m = this.$moment(value);
      return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : String(value);
    },
    formatCell(row, prop) {
      const val = row ? row[prop] : null;
      if (val === null || val === undefined || val === '') return '-';
      if (DATE_FIELDS.includes(prop)) return this.formatTime(val);
      return String(val);
    },
    formatDetailCell(row, col) {
      const val = row ? row[col.prop] : null;
      if (val === null || val === undefined || val === '') return '-';
      if (DETAIL_DATE_FIELDS.includes(col.prop)) return this.formatTime(val);
      if (col.valueType === 'cztype') return this.formatCztype(val);
      return String(val);
    },
    formatCztype(val) {
      const map = { 0: '无操作', 1: '清城小楼', 2: '有操作' };
      const key = String(val).trim();
      return map[key] !== undefined ? map[key] : val || '-';
    },
    splitUrls(val) {
      if (!val) return [];
      return String(val)
        .split(';')
        .map((s) => s.trim())
        .filter(Boolean);
    },
    isEmptyDetailValue(val) {
      if (val === null || val === undefined) return true;
      const s = String(val).trim();
      return !s || s === '-' || s === '—';
    },
    displayDetail(device, prop, valueType) {
      if (!device) return '-';
      const val = device[prop];
      if (valueType === 'cztype') {
        const formatted = this.formatCztype(val);
        return this.isEmptyDetailValue(formatted) ? '-' : formatted;
      }
      if (valueType === 'date' || DETAIL_DATE_FIELDS.includes(prop)) {
        return this.formatTime(val);
      }
      if (this.isEmptyDetailValue(val)) return '-';
      return String(val);
    },
    isValidUrl(url) {
      if (!url) return false;
      const s = String(url).trim();
      if (!s) return false;
      if (/^https?:\/\//i.test(s)) return true;
      if (s.startsWith('//')) {
        try {
          const u = new URL(`https:${s}`);
          return !!u.hostname;
        } catch (e) {
          return false;
        }
      }
      return false;
    },
    isImageUrl(url) {
      if (!this.isValidUrl(url)) return false;
      const path = String(url).trim().split('#')[0].split('?')[0];
      return /\.(jpe?g|png|gif|bmp|webp|svg)$/i.test(path);
    },
    urlFieldBlocks(device) {
      const fields = [
        { prop: 'timeout_evidence', label: '超时免责举证' },
        { prop: 'abnormalequipment', label: '异常设备固资卡照片' },
        { prop: 'abnormalissue', label: '异常问题转故障照片' },
      ];
      return fields.map((f) => {
        const urls = this.splitUrls(device[f.prop]);
        return {
          ...f,
          urls,
          imageUrls: urls.filter((u) => this.isValidUrl(u) && this.isImageUrl(u)),
        };
      });
    },
    async fetchDetailRows(ticketId) {
      if (this.detailMap[ticketId]) return this.detailMap[ticketId];
      const res = await getServerTpcDetail({ ticket_id: ticketId });
      const list = (res.data && res.data.data && res.data.data.data) || [];
      this.$set(this.detailMap, ticketId, list);
      return list;
    },
    formatDetailExportValue(row, prop) {
      const col = DETAIL_COLUMNS.find((c) => c.prop === prop);
      if (!col) return row[prop] ?? '-';
      if (col.type === 'urls') return this.splitUrls(row[prop]).join(';') || '-';
      if (col.valueType === 'cztype') return this.formatCztype(row[prop]);
      if (DETAIL_DATE_FIELDS.includes(prop)) return this.formatTime(row[prop]);
      const v = row[prop];
      return v === null || v === undefined || v === '' ? '-' : String(v);
    },
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    async getCampusData() {
      try {
        const res = await getDcopsTpcCampusOptions();
        if (res.data && res.data.code === 200) {
          const raw = (res.data.data && res.data.data.campus_list) || [];
          this.campusOptions = Array.from(new Set(raw.filter(Boolean)));
          this.hasLoaded = true;
        }
      } catch (e) {
        console.error(e);
      }
    },
    handleDateChange(val) {
      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        this.searchForm.start_time = val[0];
        this.searchForm.end_time = `${val[1]} 23:59:59`;
      } else {
        this.searchForm.start_time = null;
        this.searchForm.end_time = null;
      }
    },
    buildListParams(extra = {}) {
      const raw = {
        page: this.currentPage,
        size: this.pageSize,
        ...this.searchForm,
        ...extra,
      };
      delete raw.create_time;
      return Object.fromEntries(
        Object.entries(raw).filter(([, value]) => {
          if (value === '' || value === null || value === undefined) return false;
          if (Array.isArray(value) && value.length === 0) return false;
          return true;
        }),
      );
    },
    fetchList() {
      this.loading = true;
      getServerTpcList(this.buildListParams())
        .then((res) => {
          if (res.data && res.data.code === 200) {
            const inner = res.data.data || {};
            this.showData = inner.data || [];
            this.total = inner.total || 0;
          } else {
            this.$message.error((res.data && res.data.message) || '获取列表失败');
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.$message.error('获取列表失败');
          this.loading = false;
        });
    },
    handleExpand(row, expandedRows) {
      this.expandedRows = expandedRows || [];
      const open = expandedRows.some((r) => r.ticket_id === row.ticket_id);
      if (!open) return;
      if (this.detailMap[row.ticket_id]) return;
      this.$set(this.detailLoadingMap, row.ticket_id, true);
      getServerTpcDetail({ ticket_id: row.ticket_id })
        .then((res) => {
          const list = (res.data && res.data.data && res.data.data.data) || [];
          this.$set(this.detailMap, row.ticket_id, list);
          this.$set(this.detailLoadingMap, row.ticket_id, false);
        })
        .catch(() => {
          this.$set(this.detailLoadingMap, row.ticket_id, false);
          this.$message.error('加载明细失败');
        });
    },
    onDcopsSyncFinished() {
      this.fetchList();
      this.getCampusData();
      this.detailMap = {};
    },
    openSyncDialog() {
      this.monthSelectDialogVisible = true;
    },
    confirmSyncMonthSelect() {
      if (!this.monthSelectForm.startMonth || !this.monthSelectForm.endMonth) {
        this.$message.warning('请选择开始月份和结束月份');
        return;
      }
      const start = this.$moment(this.monthSelectForm.startMonth, 'YYYY-MM');
      const end = this.$moment(this.monthSelectForm.endMonth, 'YYYY-MM');
      if (end.isBefore(start)) {
        this.$message.warning('结束月份不能早于开始月份');
        return;
      }
      this.monthSelectDialogVisible = false;
      UpdateServerTpcList({
        start_month: this.monthSelectForm.startMonth,
        end_month: this.monthSelectForm.endMonth,
      })
        .then((res) => {
          this.handleDcopsSyncResponse(res);
        })
        .catch(() => {
          this.$message.error('同步请求失败');
        });
    },
    handleSearch() {
      this.currentPage = 1;
      this.detailMap = {};
      this.fetchList();
    },
    handleReset() {
      const now = new Date();
      const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      this.searchForm = {
        create_time: [
          this.$moment(startDate).format('YYYY-MM-DD'),
          this.$moment(endDate).format('YYYY-MM-DD'),
        ],
        start_time: null,
        end_time: null,
        is_timeout: '',
        ticket_id: '',
        campus: '',
        status: '',
        handle_user: '',
        sn: '',
        asset_id: '',
      };
      this.handleDateChange(this.searchForm.create_time);
      this.currentPage = 1;
      this.detailMap = {};
      this.fetchList();
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchList();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((x) => this.selectedColumns.includes(x.prop));
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((x) => x.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    async handleExport() {
      if (this.exportLoading) return;
      this.exportLoading = true;
      this.loading = true;
      try {
        const params = this.buildListParams({ export_excel: '1', page: 1, size: 5000 });
        const res = await getServerTpcList(params);
        const sourceRows = this.selectedRows.length
          ? this.selectedRows
          : (res.data && res.data.data && res.data.data.data) || [];
        const mainRows = sourceRows.map((row) => {
          const out = {};
          this.visibleColumns.forEach((col) => {
            if (col.prop === 'status') {
              out[col.label] = row.status || '-';
            } else if (col.prop === 'is_timeout') {
              out[col.label] = row.is_timeout || '-';
            } else {
              out[col.label] = this.formatCell(row, col.prop);
            }
          });
          return out;
        });
        const detailRows = [];
        for (const row of sourceRows) {
          const details = await this.fetchDetailRows(row.ticket_id);
          if (!details.length) {
            detailRows.push({ 工单号: row.ticket_id });
            continue;
          }
          details.forEach((d) => {
            const line = { 工单号: row.ticket_id };
            DETAIL_COLUMNS.forEach((col) => {
              line[col.label] = this.formatDetailExportValue(d, col.prop);
            });
            detailRows.push(line);
          });
        }
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(mainRows), '工单主表');
        XLSX.utils.book_append_sheet(
          wb,
          XLSX.utils.json_to_sheet(detailRows.length ? detailRows : [{ 提示: '无明细数据' }]),
          '设备明细',
        );
        XLSX.writeFile(wb, `TPC异常处理_${this.$moment().format('YYYYMMDDHHmmss')}.xlsx`);
        this.$message.success('导出成功（含工单主表与设备明细）');
      } catch (e) {
        console.error(e);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.container { padding: 20px; }
.title { font-size: 24px; font-weight: bold; margin-bottom: 30px; }
.search-container { padding: 20px; background-color: #fff; border-radius: 4px; }
.search-form { width: 100%; }
.search-button { display: flex; justify-content: flex-start; align-items: flex-start; margin-left: 10px; }
.el-form-item { margin-bottom: 18px; display: flex; }
.button-container { margin-bottom: 20px; display: flex; justify-content: flex-end; position: relative; }
.box-card { margin-bottom: 20px; }
.pagination-container { display: flex; justify-content: flex-end; margin-top: 16px; }
.title-en { margin: 10px 0; padding-left: 10px; border-left: 3px solid #219aff; font-weight: normal; }
.checkbox-group { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; padding: 10px; max-height: 300px; overflow-y: auto; }
.checkbox-item { margin-right: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.dialog-footer { text-align: right; padding-top: 15px; border-top: 1px solid #ebeef5; }
.dialog-footer .el-button + .el-button { margin-left: 8px; }
.detail-expand-wrap {
  padding: 16px 20px 20px;
  background: linear-gradient(180deg, #f5f9ff 0%, #fafafa 100%);
}
.detail-summary-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.detail-summary-id {
  font-size: 13px;
  color: #909399;
}
.device-card {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  margin-bottom: 14px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.device-card-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 16px;
  background: #ecf5ff;
  border-bottom: 1px solid #d9ecff;
}
.device-badge {
  font-size: 12px;
  font-weight: 600;
  color: #219aff;
}
.device-asset {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.device-card-body {
  padding: 14px 16px 4px;
}
.info-panel,
.attach-panel {
  margin-bottom: 12px;
}
.panel-title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}
.panel-title i {
  color: #219aff;
  margin-right: 4px;
}
.text-block {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
}
.mini-timeline {
  margin-top: 12px;
  padding-left: 4px;
  border-left: 2px solid #dcdfe6;
}
.timeline-node {
  position: relative;
  padding: 0 0 10px 14px;
  font-size: 12px;
}
.timeline-node .dot {
  position: absolute;
  left: -7px;
  top: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #c0c4cc;
}
.timeline-node .dot.on {
  background: #219aff;
}
.timeline-node .label {
  color: #606266;
  margin-right: 8px;
}
.timeline-node .time {
  color: #909399;
}
.attach-panel {
  padding: 0 16px 14px;
  border-top: 1px dashed #ebeef5;
  padding-top: 12px;
}
.url-block {
  background: #fafafa;
  border-radius: 6px;
  padding: 10px;
  min-height: 80px;
}
.url-block-label {
  font-size: 12px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}
.url-empty,
.url-not-link {
  color: #909399;
  font-size: 12px;
}
.url-block-content {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-start;
}
.url-image-item {
  flex: 0 0 auto;
}
.url-preview-img {
  width: 88px;
  height: 88px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  cursor: pointer;
}
.url-download-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #219aff;
  font-size: 12px;
  font-weight: 500;
}
.url-download-link:hover {
  text-decoration: underline;
}

::v-deep .tpc-detail-expand-col .el-table__expand-icon {
  color: #219aff;
  font-weight: 700;
  font-size: 14px;
}
::v-deep .tpc-detail-expand-col .el-table__expand-icon .el-icon {
  font-weight: 700;
}
::v-deep .tpc-detail-expand-col .el-table__expand-icon--expanded {
  color: #219aff;
}
::v-deep .tpc-table .el-table__body-wrapper {
  width: 100% !important;
}
::v-deep .tpc-table.el-table--border::after,
::v-deep .tpc-table.el-table--group::after {
  width: 0;
}

::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

::v-deep .el-table__expanded-cell {
  padding: 0 !important;
}
</style>
